<template>
  <div>
    <div v-if="ready" :key="choices">
      <div class="question">
        {{ current.qText }}
      </div>
      <div class="qOptions">
        <form v-if="undecided" id="prngChoice" action="javascript:void(0);">
          <div v-for="(resp, idx) in current.qOptions" :key="idx" class="optionRow">
            <div class="selector">
              <input type="radio" name="choices"
                     v-model="choicePicked" :id="resp.optionId"
                     :value="resp.optionId"/>
            </div>
            <div class="descriptor">
              <label :for="resp.optionId">{{ resp.optionText }}</label>
            </div>
          </div>
          <div>
            <button @click="reverse" class="back" type="button">Back</button>
            <button @click="update(choicePicked)" class="forward" type="button">Next</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {apiQuestions} from "../api/questions"
import {buildTree} from "../api/tree"
import {ref} from "vue"

function getQfromStack(nodes, choices) {
  let cNode = nodes;

  if (choices.length > 0) {
    for (let cIndx in choices) {
      let _chce = choices[cIndx];
      let _next = cNode.responses[_chce];
      cNode = cNode.responses[_chce].question;
      if (_next.type === "feature_value") {
        let nextKey = Object.keys(_next.question)[0];
        cNode = _next.question[nextKey];
      }
    }
  }
  if (cNode.type === "result") {
    return {
      qText: cNode.name,
      qOptions: [],
      undecided: false
    };
  }


  let opts = [];
  for (let optIndx in cNode.responses) {
    opts.push({
      optionId: cNode.responses[optIndx].id,
      optionText: cNode.responses[optIndx].name,
    })
  }

  return {
    qText: cNode.name,
    qOptions: opts,
    undecided: true
  }
}

export default {
  name: "Question",
  data() {
    let treeData = ref({});
    let questions = ref([]);
    let ready = ref(false);
    let choices = ref([]);
    let choicePicked = ref('');
    let current = ref({})

    buildTree(treeData, (val) => {
      ready.value = val;
      current.value = getQfromStack(treeData.value["adj"], choices.value);
    })
    apiQuestions(questions);
    return {
      treeData: treeData,
      questions: questions,
      choices: choices,
      ready: ready,
      choicePicked: choicePicked,
      current: current,
      undecided: true,
    };
  },
  methods: {
    update(choice) {
      this.choices.push(choice);
      this.choicePicked = "";
      this.current = getQfromStack(this.treeData.adj, this.choices);
      this.undecided = this.current.undecided;
      if (!this.undecided) {
        this.$router.push("/algo/"+(parseInt(this.current.qText) + 1));
      }
      this.ready = true;
    },
    reverse() {
      this.choicePicked = this.choices.pop();
      this.current = getQfromStack(this.treeData.adj, this.choices);
      this.ready = true;
    }
  }
}

</script>

<style scoped>
.question {
  width: 600px;
  text-align: center;
  font-size: 25px;
  background: rgba(100, 149, 237, 0.18);
  border-bottom: 1px solid grey;
  padding: 30px;
  margin-bottom: 10px;
}

.qOptions {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
}

.optionRow {
  font-size: 20px;
  display: flex;
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
  align-items: center;


}

.selector {
  width: 35px;
}

.descriptor {
  width: 400px;
}
.back {
  margin-right: 20px;
  font-size: 15px;
  background: firebrick;
  color: white;
  font-weight: bolder;
  border: none;
  padding: 15px;
  border-radius: 10px;
}

.forward {
  margin-left: 20px;
  font-size: 15px;
  background: seagreen;
  color: white;
  font-weight: bolder;
  border: none;
  padding: 15px 55px;
  border-radius: 10px;
}
</style>